module.exports = __webpack_public_path__ + "img/expired.8531c32f.png";